import * as React from 'react';
import { EgTnlBucket } from '@expediagroup/egtnl-bucket-web';
import fetch from 'isomorphic-fetch';
import { NOOP_LOGGER, getErrorString } from 'bernie-logger';
import { UniqueBatchQueue, BERNIE_CORE_EVENTS } from 'bernie-core';
import { ExperimentProvider } from '@shared-ui/experiment-context';

var AbacusExperimentStoreDelegate = /** @class */ (function () {
    function AbacusExperimentStoreDelegate(experimentContext, logger) {
        this.experimentContext = experimentContext;
        this.logger = logger;
        this.getExposure = this.getExposure.bind(this);
        this.logExperiment = this.logExperiment.bind(this);
        this.serialize = this.serialize.bind(this);
    }
    Object.defineProperty(AbacusExperimentStoreDelegate.prototype, "exposures", {
        get: function () {
            return this.experimentContext;
        },
        enumerable: false,
        configurable: true
    });
    AbacusExperimentStoreDelegate.prototype.getExposure = function (name) {
        var _a;
        if ((_a = this.experimentContext) === null || _a === void 0 ? void 0 : _a.exposures) {
            return this.experimentContext.exposures[name];
        }
        return null;
    };
    AbacusExperimentStoreDelegate.prototype.logExperiment = function (exposure) {
        this.logger.logExperiment(exposure);
    };
    AbacusExperimentStoreDelegate.prototype.serialize = function (currentData) {
        var _a;
        var initialData = currentData || {};
        var exposures = Object.values(((_a = this.experimentContext) === null || _a === void 0 ? void 0 : _a.exposures) || {}).reduce(function (acc, value) {
            acc[value.name] = {
                name: value.name,
                bucket: value.bucket,
            };
            return acc;
        }, initialData);
        return { exposures: exposures };
    };
    return AbacusExperimentStoreDelegate;
}());

var EgtnlBrowserDelegate = /** @class */ (function () {
    function EgtnlBrowserDelegate(evaluator, context, pageData, exposureData) {
        this.evaluator = evaluator;
        this.context = context;
        this.pageData = pageData;
        this.exposureData = exposureData;
        this.getExposure = this.getExposure.bind(this);
        this.logExperiment = this.logExperiment.bind(this);
    }
    Object.defineProperty(EgtnlBrowserDelegate.prototype, "exposures", {
        get: function () {
            return this.exposureData;
        },
        enumerable: false,
        configurable: true
    });
    EgtnlBrowserDelegate.prototype.getExposure = function (name) {
        var _a;
        if ((_a = this.exposureData) === null || _a === void 0 ? void 0 : _a.exposures) {
            return this.exposureData.exposures[name];
        }
        return null;
    };
    EgtnlBrowserDelegate.prototype.logExperiment = function (exposure) {
        var _a, _b;
        if (exposure && ((_b = (_a = this.exposureData) === null || _a === void 0 ? void 0 : _a.exposures) === null || _b === void 0 ? void 0 : _b[exposure.name])) {
            var evaluationData = this.exposureData.exposures[exposure.name];
            this.evaluator().logExperiment(evaluationData.evaluationData, [this.context, this.pageData, exposure]);
        }
    };
    return EgtnlBrowserDelegate;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var TIMEOUT = 400;
/**
 * Retrieves and configures an `ExperimentLogger`.
 * @param options Configuration options, e.g. the base URL for server side calls
 */
var getAbacusApiServerExperimentLogger = function (options) {
    var baseUrl = options.baseUrl || '';
    var logger = options.logger || NOOP_LOGGER;
    var loggedExperiments = new Set();
    var queue;
    var fetchWithTimeout = function (url, requestOptions) {
        var fetchOptions = requestOptions;
        if (typeof window === 'undefined' && typeof options.timeout === 'number') {
            fetchOptions = __assign(__assign({}, fetchOptions), { timeout: options.timeout });
        }
        return fetch(url, fetchOptions);
    };
    /**
     * Using the Abacus public API, log a batch of exposures.
     * @param context The platform `Context`.
     * @param pageData The `PageData` store containing `pageName`.
     * @param exposure An Abacus exposure.
     */
    return function (context, pageData, exposure) {
        var _a;
        var overrides = ((_a = context === null || context === void 0 ? void 0 : context.debugContext) === null || _a === void 0 ? void 0 : _a.abacusOverrides) || [];
        if (queue === undefined) {
            queue = new UniqueBatchQueue(TIMEOUT, function (e) { return e.name; }, function (exposures) {
                fetchWithTimeout("".concat(baseUrl, "/api/bucketing/v1/evaluateExperimentsAndLog"), {
                    body: JSON.stringify({
                        guid: context.deviceId,
                        tpid: context.site.tpid,
                        eapid: context.site.eapid,
                        pageName: pageData.pageName,
                        name: exposures.map(function (item) { return item.name; }),
                        overrides: overrides.map(function (override) { return "".concat(override.id, "|0|").concat(override.bucket); }).join(':') || undefined,
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    method: 'POST',
                })
                    .then(function () {
                    exposures.forEach(function (e) {
                        loggedExperiments.add(e.name);
                    });
                })
                    .catch(function (error) {
                    if (logger) {
                        logger.logEvent(BERNIE_CORE_EVENTS.LOG_EXPERIMENT_ERROR, getErrorString(error));
                    }
                });
            });
        }
        if (!loggedExperiments.has(exposure.name)) {
            queue.add(exposure);
        }
        return true;
    };
};

var adaptAbacusLogger = function (logger, context, pageData) {
    return {
        logExperiment: function (exposure) {
            logger(context, pageData, exposure);
        },
    };
};
var getEGCSCallbacks = function (logger) {
    return {
        onFetchError: function (error) {
            logger.info('EGTNL_EGCS_FETCH_ERROR', "EGTNL EGCS failed on fetch. ".concat(error));
        },
        onInvalidPayload: function (error) {
            logger.info('EGTNL_EGCS_INVALID_PAYLOAD', "EGTNL EGCS failed due to invalid payload. ".concat(error));
        },
        onPublishError: function (error) {
            logger.info('EGTNL_EGCS_PUBLISH_ERROR', "EGTNL EGCS failed on publish. ".concat(error));
        },
    };
};
var getExperimentLoggers = function (logger) {
    var egcsCallbacks = getEGCSCallbacks(logger);
    var clickStreamLogger = EgTnlBucket.egLogger(egcsCallbacks);
    return [clickStreamLogger];
};
var initializeEgtnlBucket = function (exposureData, context, pageData, logger) {
    var bucketData = Object.values(exposureData.exposures)
        .map(function (e) { return e.evaluationData; })
        .filter(function (e) { return e; })
        .reduce(function (acc, value) {
        var _a;
        if ((_a = value === null || value === void 0 ? void 0 : value.experimentKey) === null || _a === void 0 ? void 0 : _a.experimentId) {
            acc[value.experimentKey.experimentId] = value;
        }
        return acc;
    }, {});
    EgTnlBucket.initialize(EgTnlBucket.bucketConfig(bucketData, getExperimentLoggers(logger)));
    return new EgtnlBrowserDelegate(EgTnlBucket.evaluator, context, pageData, exposureData);
};
var buildExperimentStore = function (exposureData, context, pageData, logger, egtnlEnabled, abacusEnabled) {
    var delegates = [];
    if (abacusEnabled) {
        var abacusLogger = adaptAbacusLogger(getAbacusApiServerExperimentLogger({ logger: logger }), context, pageData);
        var abacusDelegate = new AbacusExperimentStoreDelegate(exposureData, abacusLogger);
        delegates.push(abacusDelegate);
    }
    if (egtnlEnabled) {
        var egtnlBrowserDelegate = initializeEgtnlBucket(exposureData, context, pageData, logger);
        delegates.push(egtnlBrowserDelegate);
    }
    return new BrowserExperimentStore(delegates);
};
var BrowserExperimentStore = /** @class */ (function () {
    function BrowserExperimentStore(delegates) {
        this.delegates = delegates;
        this.getExposure = this.getExposure.bind(this);
        this.logExperiment = this.logExperiment.bind(this);
    }
    BrowserExperimentStore.prototype.getExposure = function (name) {
        var result = this.delegates.reduce(function (currentExposure, delegate) {
            return delegate.getExposure(name);
        }, undefined);
        return result;
    };
    BrowserExperimentStore.prototype.logExperiment = function (exposure) {
        if (exposure) {
            this.delegates.forEach(function (d) {
                d.logExperiment(exposure);
            });
        }
    };
    return BrowserExperimentStore;
}());

var getExperimentContext = function (appData) {
    var experimentContextStore = appData.experimentContextStore;
    return experimentContextStore;
};
var getExperimentProvider = function (options, appData) {
    if (appData.experimentContextStore && options.enableExperimentProvider !== false) {
        // eslint-disable-next-line react/display-name
        return function (props) { return (React.createElement(ExperimentProvider, { config: getExperimentContext(appData) }, props.children)); };
    }
    return function (props) { return props.children; };
};

function ExperimentStorePlugin(pluginOptions) {
    if (pluginOptions === void 0) { pluginOptions = {}; }
    var _a = pluginOptions.egtnlEnabled, egtnlEnabled = _a === void 0 ? false : _a, _b = pluginOptions.abacusEnabled, abacusEnabled = _b === void 0 ? true : _b;
    return {
        name: 'experiment-store',
        onBrowserHydrateRenderContext: function (pluginContext, next) {
            var hydratedState = pluginContext.hydratedState, getAppData = pluginContext.getAppData, setAppData = pluginContext.setAppData;
            var appData = getAppData();
            var logger = appData.logger;
            var experimentStore = hydratedState.experimentStore;
            var experimentContextStore = buildExperimentStore(experimentStore, appData.context, appData.pageDataContext, logger, egtnlEnabled, abacusEnabled);
            setAppData({ experimentContextStore: experimentContextStore });
            return next(pluginContext);
        },
        onBrowserWrapRootElement: function (pluginContext, next) {
            var getAppData = pluginContext.getAppData, setRootElement = pluginContext.setRootElement;
            var appData = getAppData();
            var ExperimentContextProvider = getExperimentProvider(pluginOptions, appData);
            // eslint-disable-next-line react/display-name
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(ExperimentContextProvider, null,
                React.createElement(RootElement, null, props.children))); }; });
            return next(pluginContext);
        },
    };
}

export { ExperimentStorePlugin as default };
//# sourceMappingURL=browser.js.map
